import { render, screen } from "@testing-library/react";
import OktaSignInWidget from "./OktaSignInWidget";

test("check rendering of sign in widget", async () => {
  render(<OktaSignInWidget onSuccess={() => {}} onError={() => {}} />);
  const loginForm = await screen.findByTestId("hiw-login-container");
  expect(loginForm).toBeInTheDocument();
});
